import React from 'react';
import Moment from 'react-moment';

const Card = ({name, rating, releaseDate, image, genres, metacritic}) =>  {
    return (
            <div className='tc grow bg-lightest-blue br3 pa3 ma2 dib bw2 shadow-5'>
                <div>
                    <img className='bimage' src={image} alt='game'/>
                    <h2>{name}</h2>
                    <p>Release Date : <Moment format="MMM Do YYYY" >{releaseDate}</Moment></p>
                    <p>Rating: {rating} </p>
                    <p>Genres : {genres}</p>
                    <p>Metacritic Score : {metacritic}</p>
                </div>
            </div>
    );
}

export default Card;